import { createReduxAsyncThunk } from 'shared/utils';
import { carsAPI } from 'entities/cars';

import { CARS_STATE } from '../../constants';

import { CarEBoxLocations } from '../../types';

export const getCarEBoxLocations = createReduxAsyncThunk<CarEBoxLocations>(
  `${CARS_STATE}/getClientEBoxLocations`,
  async () => {
    const { data } = await carsAPI.getCarEBoxLocations();
    return data;
  }
);